import { render } from "./DeleteDicomListConfirmPopup.vue?vue&type=template&id=46c3a1d2&scoped=true&ts=true"
import script from "./DeleteDicomListConfirmPopup.vue?vue&type=script&lang=ts"
export * from "./DeleteDicomListConfirmPopup.vue?vue&type=script&lang=ts"

import "./DeleteDicomListConfirmPopup.vue?vue&type=style&index=0&id=46c3a1d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c3a1d2"]])

export default __exports__